import { GenIcon } from '../helpers/IconBase.es.js';

const DinoOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "circle",
        attr: {
          cx: "12",
          cy: "12",
          r: "9.2",
          stroke: "#434657",
          strokeWidth: "1.6"
        }
      },
      {
        tag: "mask",
        attr: {
          id: "icon-vt4hq37qo",
          maskUnits: "userSpaceOnUse",
          x: "8",
          y: "6",
          width: "9",
          height: "12",
          fill: "black"
        },
        child: [
          {
            tag: "rect",
            attr: { fill: "white", x: "8", y: "6", width: "9", height: "12" }
          },
          {
            tag: "path",
            attr: {
              d: "M12.4797 7C13.1386 7 13.7028 7.1264 14.1721 7.37921C14.6505 7.62266 15.0567 7.98315 15.3907 8.46067C15.5351 8.67603 15.648 8.90543 15.7292 9.14888C15.8195 9.38296 15.8827 9.64513 15.9188 9.93539C15.9549 10.2163 15.9774 10.53 15.9865 10.8764C15.9955 11.2135 16 11.588 16 12C16 12.412 15.9955 12.7912 15.9865 13.1376C15.9774 13.4747 15.9549 13.7884 15.9188 14.0787C15.8827 14.3595 15.8195 14.6217 15.7292 14.8652C15.648 15.0993 15.5351 15.324 15.3907 15.5393C15.0567 16.0169 14.6505 16.382 14.1721 16.6348C13.7028 16.8783 13.1386 17 12.4797 17H9V7H12.4797ZM10.882 8.74157V15.2584H12.3172C12.94 15.2584 13.4094 15.0524 13.7253 14.6405C13.8156 14.5281 13.8833 14.4064 13.9284 14.2753C13.9826 14.1348 14.0232 13.9616 14.0503 13.7556C14.0774 13.5496 14.0954 13.3062 14.1044 13.0253C14.1135 12.735 14.118 12.3933 14.118 12C14.118 11.6067 14.1135 11.2697 14.1044 10.9888C14.0954 10.6985 14.0774 10.4551 14.0503 10.2584C14.0232 10.0524 13.9826 9.87921 13.9284 9.73876C13.8833 9.59831 13.8156 9.47191 13.7253 9.35955C13.4094 8.94757 12.94 8.74157 12.3172 8.74157H10.882Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          d: "M12.4797 7C13.1386 7 13.7028 7.1264 14.1721 7.37921C14.6505 7.62266 15.0567 7.98315 15.3907 8.46067C15.5351 8.67603 15.648 8.90543 15.7292 9.14888C15.8195 9.38296 15.8827 9.64513 15.9188 9.93539C15.9549 10.2163 15.9774 10.53 15.9865 10.8764C15.9955 11.2135 16 11.588 16 12C16 12.412 15.9955 12.7912 15.9865 13.1376C15.9774 13.4747 15.9549 13.7884 15.9188 14.0787C15.8827 14.3595 15.8195 14.6217 15.7292 14.8652C15.648 15.0993 15.5351 15.324 15.3907 15.5393C15.0567 16.0169 14.6505 16.382 14.1721 16.6348C13.7028 16.8783 13.1386 17 12.4797 17H9V7H12.4797ZM10.882 8.74157V15.2584H12.3172C12.94 15.2584 13.4094 15.0524 13.7253 14.6405C13.8156 14.5281 13.8833 14.4064 13.9284 14.2753C13.9826 14.1348 14.0232 13.9616 14.0503 13.7556C14.0774 13.5496 14.0954 13.3062 14.1044 13.0253C14.1135 12.735 14.118 12.3933 14.118 12C14.118 11.6067 14.1135 11.2697 14.1044 10.9888C14.0954 10.6985 14.0774 10.4551 14.0503 10.2584C14.0232 10.0524 13.9826 9.87921 13.9284 9.73876C13.8833 9.59831 13.8156 9.47191 13.7253 9.35955C13.4094 8.94757 12.94 8.74157 12.3172 8.74157H10.882Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.4797 7C13.1386 7 13.7028 7.1264 14.1721 7.37921C14.6505 7.62266 15.0567 7.98315 15.3907 8.46067C15.5351 8.67603 15.648 8.90543 15.7292 9.14888C15.8195 9.38296 15.8827 9.64513 15.9188 9.93539C15.9549 10.2163 15.9774 10.53 15.9865 10.8764C15.9955 11.2135 16 11.588 16 12C16 12.412 15.9955 12.7912 15.9865 13.1376C15.9774 13.4747 15.9549 13.7884 15.9188 14.0787C15.8827 14.3595 15.8195 14.6217 15.7292 14.8652C15.648 15.0993 15.5351 15.324 15.3907 15.5393C15.0567 16.0169 14.6505 16.382 14.1721 16.6348C13.7028 16.8783 13.1386 17 12.4797 17H9V7H12.4797ZM10.882 8.74157V15.2584H12.3172C12.94 15.2584 13.4094 15.0524 13.7253 14.6405C13.8156 14.5281 13.8833 14.4064 13.9284 14.2753C13.9826 14.1348 14.0232 13.9616 14.0503 13.7556C14.0774 13.5496 14.0954 13.3062 14.1044 13.0253C14.1135 12.735 14.118 12.3933 14.118 12C14.118 11.6067 14.1135 11.2697 14.1044 10.9888C14.0954 10.6985 14.0774 10.4551 14.0503 10.2584C14.0232 10.0524 13.9826 9.87921 13.9284 9.73876C13.8833 9.59831 13.8156 9.47191 13.7253 9.35955C13.4094 8.94757 12.94 8.74157 12.3172 8.74157H10.882Z",
          stroke: "#434657",
          strokeWidth: "0.4",
          mask: "url(#icon-vt4hq37qo)"
        }
      }
    ]
  })(props);
};

export { DinoOutlined };
